export const institutionsConstants = {
  GET_INSTITUTIONS_REQUEST: "GET_INSTITUTIONS_REQUEST",
  GET_INSTITUTIONS_SUCCESS: "GET_INSTITUTIONS_SUCCESS",
  GET_INSTITUTIONS_FAILURE: "GET_INSTITUTIONS_FAILURE",
  GET_INSTITUTIONS_RESET: "GET_INSTITUTIONS_RESET",

  VIEW_INSTITUTION_REQUEST: "VIEW_INSTITUTION_REQUEST",
  VIEW_INSTITUTION_SUCCESS: "VIEW_INSTITUTION_SUCCESS",
  VIEW_INSTITUTION_FAILURE: "VIEW_INSTITUTION_FAILURE",
  VIEW_INSTITUTION_RESET: "VIEW_INSTITUTION_RESET",

  ADD_INSTITUTION_REQUEST: "ADD_INSTITUTION_REQUEST",
  ADD_INSTITUTION_SUCCESS: "ADD_INSTITUTION_SUCCESS",
  ADD_INSTITUTION_FAILURE: "ADD_INSTITUTION_FAILURE",
  ADD_INSTITUTION_RESET: "ADD_INSTITUTION_RESET",

  EDIT_INSTITUTION_REQUEST: "EDIT_INSTITUTION_REQUEST",
  EDIT_INSTITUTION_SUCCESS: "EDIT_INSTITUTION_SUCCESS",
  EDIT_INSTITUTION_FAILURE: "EDIT_INSTITUTION_FAILURE",
};
